import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { footerEngageNav, footerFirmNav } from '../../data/navigation';
import { visibleNavItems } from '../../utils/features';
import type { NavItem } from '../../types/content';
export function Footer() {
  const year = new Date().getFullYear();
  return <footer className="bg-midnight-950 text-champagne-100" data-id="element-107" data-mp="5mkkm4mvj5qn">
      <div className="mx-auto grid max-w-site gap-12 px-6 py-16 lg:grid-cols-12 lg:px-10 lg:py-20" data-id="element-108" data-mp="oj3vqcx7iic">
        <div className="lg:col-span-5" data-id="element-109" data-mp="3s25ag6ws19fd">
          <Logo data-id="element-110" data-mp="3s13w9tkgs6tf" />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-champagne-100/65" data-id="element-111" data-mp="3s0kj0q5re6lq">
            Retained executive search and leadership advisory for boards, chief executives, and investors.
          </p>
        </div>
        <FooterColumn title="The Firm" items={visibleNavItems(footerFirmNav)} data-id="element-112" data-mp="3e2w3lxugnro2" />
        <FooterColumn title="Engage" items={visibleNavItems(footerEngageNav)} data-id="element-113" data-mp="3e4qh4r3ekhi4" />
        <div className="lg:col-span-3" data-id="element-114" data-mp="394kwvvzgpxa2">
          <h2 className="text-xs font-medium uppercase tracking-[0.2em] text-champagne-400" data-id="element-115" data-mp="2kdd1eqhs0vpm">Get in touch</h2>
          <p className="mt-5 text-sm leading-relaxed text-champagne-100/65" data-id="element-116" data-mp="2p4cxjtj2n9r2">
            All inquiries are handled confidentially through our inquiry form.
          </p>
          <Link to="/contact" className="mt-4 inline-block text-sm font-medium text-champagne-200 underline decoration-champagne-300/40 underline-offset-4 transition-colors duration-150 ease-out hover:text-champagne-50" data-id="element-117" data-mp="2balnmk1fhnut">
            Send an inquiry
          </Link>
        </div>
      </div>
      <div className="border-t border-champagne-100/10" data-id="element-118" data-mp="2u3frahtlptjq">
        <div className="mx-auto flex max-w-site flex-col gap-2 px-6 py-6 text-xs text-champagne-100/50 sm:flex-row sm:justify-between lg:px-10" data-id="element-119" data-mp="2u2o3ht68x040">
          <p data-id="element-120" data-mp="1in7wj2kevmim">© {year} Qorvessa Executive Partners. All rights reserved.</p>
          <p data-id="element-121" data-mp="1nmu9rc08p2rf">Confidential executive search &amp; leadership advisory.</p>
        </div>
      </div>
    </footer>;
}
function FooterColumn({
  title,
  items
}: {
  title: string;
  items: NavItem[];
}) {
  return <div className="lg:col-span-2" data-id="element-122" data-mp="zje77git5gu3">
      <h2 className="text-xs font-medium uppercase tracking-[0.2em] text-champagne-400" data-id="element-123" data-mp="zk78i1yzze4u">{title}</h2>
      <ul className="mt-5 space-y-3" data-id="element-124" data-mp="ure3dczma3s8">
        {items.map(item => <li key={item.to} data-id="element-125" data-mp="ptums6fg5ex4">
            <Link to={item.to} className="text-sm text-champagne-100/75 transition-colors duration-150 ease-out hover:text-champagne-50" data-id="element-126" data-mp="psjj06m04760">
              {item.label}
            </Link>
          </li>)}
      </ul>
    </div>;
}